(() => {
  const source = document.getElementById('BrunoModelVariationsConfig');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  const quote = value => '"' + String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  const baseFor = value => {
    const words = value.toLowerCase().match(/[\p{L}\p{N}-]+/gu) || [];
    const meaningful = words.filter(word => !['de', 'del', 'para', 'la', 'el', 'y', 'repuesto', 'repuestos', 'pieza', 'piezas', 'moto', 'motos'].includes(word));
    const category = config.categories[meaningful.join(' ')];
    return category ? 'product_type:' + quote(category) : meaningful.map(word => 'title:' + quote(word)).join(' AND ');
  };
  const resolve = value => {
    const raw = String(value || '').trim();
    if (!raw || /[:"()]/.test(raw) || raw.length > 200) return null;
    const words = raw.split(/\s+/);
    for (let size = words.length; size > 0; size -= 1) {
      for (let start = 0; start + size <= words.length; start += 1) {
        const ids = config.aliases[normalize(words.slice(start, start + size).join(' '))];
        if (ids) return { raw, ids, base: baseFor([...words.slice(0, start), ...words.slice(start + size)].join(' ')) };
      }
    }
    return null;
  };
  const compose = (base, model) => {
    let clause = 'tag:' + quote(model.sourceTag);
    if (model.brand) clause += ' AND tag:' + quote(model.brand);
    if (model.tag === 'ARES250X') clause += ' AND -product_type:"Motor"';
    return base ? '(' + base + ') AND (' + clause + ')' : clause;
  };
  const destination = (match, id) => {
    const model = config.models[id];
    const url = new URL(config.searchUrl, location.origin);
    url.searchParams.set('q', compose(match.base, model));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('bruno_alias_model', id);
    url.searchParams.set('bruno_model', model.tag);
    url.searchParams.set('bruno_base_q', match.base);
    url.searchParams.set('bruno_alias_query', match.raw);
    const current = new URL(location.href);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    return url;
  };
  const context = current => {
    const model = config.models[current.searchParams.get('bruno_alias_model')];
    const base = current.searchParams.get('bruno_base_q') || '';
    if (!model || compose(base, model) !== current.searchParams.get('q')) return null;
    return { tag: model.tag, base, label: model.label };
  };
  window.brunoModelVariations = { context };
  let dialog;
  const choose = match => {
    if (dialog?.open) dialog.close();
    dialog?.remove();
    dialog = document.createElement('dialog');
    dialog.className = 'bruno-model-choice';
    dialog.setAttribute('aria-labelledby', 'BrunoModelChoiceTitle');
    const title = document.createElement('h2');
    title.id = 'BrunoModelChoiceTitle';
    title.textContent = config.text.title;
    const description = document.createElement('p');
    description.textContent = config.text.description;
    const list = document.createElement('ul');
    for (const id of match.ids) {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = destination(match, id).href;
      link.textContent = config.models[id].label;
      item.append(link);
      list.append(item);
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = config.text.close;
    close.addEventListener('click', () => dialog.close());
    dialog.append(title, description, list, close);
    document.body.append(dialog);
    dialog.showModal();
  };
  const route = (match, replace = false) => {
    if (match.ids.length > 1) choose(match);
    else if (replace) location.replace(destination(match, match.ids[0]).href);
    else location.assign(destination(match, match.ids[0]).href);
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const url = new URL(form.action, location.origin);
    if (url.origin !== location.origin || url.pathname !== config.searchUrl) return;
    const input = form.querySelector('input[name="q"]');
    const match = resolve(input?.value);
    if (!match) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    route(match);
  }, true);
  const current = new URL(location.href);
  if (current.pathname === config.searchUrl) {
    const query = current.searchParams.get('q') || '';
    const match = resolve(query);
    if (match) route(match, true);
    const active = context(current);
    if (active) {
      const original = current.searchParams.get('bruno_alias_query') || active.label;
      document.querySelectorAll('input[name="q"]').forEach(input => { if (input.value === query) input.value = original; });
      const heading = document.querySelector('.bc-search .bc-heading h1');
      if (heading) heading.textContent = original;
      document.title = original + ' – ' + document.title.split(' – ').at(-1);
    }
  }
})();
